import { red } from "@ant-design/colors"
import { faSlidersV } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Col, Form, Row, Select, Typography } from "antd"
import { useContext } from "react"
import { useQuickBooksSalesTaxesQuery } from "../../SystemSetup/QuickBooks/quickBooksQueries"
import TenantsContext from "../TenantsContext"

const { Title, Text } = Typography

const QboSettingsSection = () => {
  const { state: { tenant }, dispatch, isUSQuickBooksAccount: isCurrentUserFromUS } = useContext(TenantsContext)

  const quickBooksSalesTaxesQuery = useQuickBooksSalesTaxesQuery(!isCurrentUserFromUS)
  const options = quickBooksSalesTaxesQuery.data?.map(x => ({ label: x.name, value: parseInt(x.id) })) || []

  return <section>
    <Title level={5}><FontAwesomeIcon icon={faSlidersV} /> QuickBooks Default Settings</Title>
    <hr />
    <Row gutter={24}>
      <Col span={6}>
        <Form.Item label={<Text>Sales Tax <small style={{ color: red.primary }}>*required</small></Text>}>
          <Select
            value={tenant.defaultQboSalesTaxId}
            onChange={value => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'defaultQboSalesTaxId', payload: value })}
            options={options}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={<Text>Exempt Sales Tax <small style={{ color: red.primary }}>*required</small></Text>}>
          <Select
            value={tenant.defaultQboExemptSalesTaxId}
            onChange={value => dispatch({ type: 'SET_TENANT_FIELD', fieldName: 'defaultQboExemptSalesTaxId', payload: value })}
            options={options}
          />
        </Form.Item>
      </Col>
    </Row>
  </section>
}

export default QboSettingsSection